export default __webpack_public_path__ + "static/media/img-0780-portugal-full-face.679cf014.png";